import { apiConfig } from "./api";
import { constants } from "./constants";

export const config = { api: apiConfig, constants };
